import TYPES from './types';

export const INITIAL_STATE = {
    email: null,
    idToken: null,
    refreshToken: null,
    expiresAt: null,
    loggedIn: false,
};

// Load user data from local storage
export const INIT = function (initialValue = INITIAL_STATE) {
    return JSON.parse(localStorage.getItem('user')) || initialValue;
};

const AuthReducer = function (state, action) {
    switch (action.type) {
        case TYPES.INIT: {
            return { ...INITIAL_STATE };
        }
        case TYPES.LOGIN: {
            return {
                ...state,
                email: action.payload.email,
                idToken: action.payload.idToken,
                refreshToken: action.payload.refreshToken,
                expiresAt: action.payload.expiresAt,
            };
        }
        case TYPES.LOGOUT: {
            return { ...INITIAL_STATE };
        }
        case TYPES.REFRESH_TOKEN: {
            return {
                ...state,
                idToken: action.payload.idToken,
                refreshToken: action.payload.refreshToken,
                expiresAt: action.payload.expiresAt,
            };
        }
        case TYPES.RESET_PASSWORD: {
            return { ...state };
        }
        case TYPES.COMPLETE_LOGIN: {
            return {
                ...state,
                loggedIn: true,
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default AuthReducer;